import { isWebView } from './base';

/**
 * meInfo 변경 시 WebView 메시지를 전송하는 함수
 * localStorage의 meInfo가 변경되거나 사용자 정보가 업데이트될 때 호출됩니다.
 * 
 * @param {Object} userData - 사용자 데이터 객체 (선택사항, 없으면 localStorage에서 가져옴)
 * @param {Array} userLevels - 사용자 레벨 데이터 (선택사항, 없으면 localStorage에서 가져옴)
 */
export const sendWebViewMeInfoMessage = (userData = null, userLevels = null) => {

    if (!isWebView()) {
        return;
    }

    try {
        // userData 가져오기
        let parsedUserData = userData;
        if (!parsedUserData) {
            const storedInfo = localStorage.getItem('meInfo');
            if (storedInfo) {
                try {
                    parsedUserData = JSON.parse(storedInfo);
                } catch (parseError) {
                    return;
                }
            } else {
                // userData가 없으면 메시지 전송하지 않음                
                return;
            }
        }

        // userLevels 가져오기
        let levels = userLevels;
        if (!levels) {
            const cachedLevels = localStorage.getItem('userLevels');
            if (cachedLevels) {
                try {
                    const parsed = JSON.parse(cachedLevels);
                    // 응답 구조에 따라 파싱
                    levels = parsed?.data?.userLevels || parsed?.userLevels || (Array.isArray(parsed) ? parsed : null);
                } catch (e) {
                    console.warn('Failed to parse cached userLevels:', e);
                }
            }
        }

        // userLevels가 없으면 메시지 전송하지 않음
        if (!levels || !Array.isArray(levels) || levels.length === 0) {
            return;
        }

        // parsedUserData에 level이 없으면 메시지 전송하지 않음
        if (!parsedUserData.level) {
            return;
        }

        // totalExp 계산
        const userLevel = levels.find(level => level.level === parsedUserData.level);
        const totalExp = userLevel?.totalExp || 0;
        const requiredExp = userLevel?.requiredExp || 0;

        // WebView 메시지 전송
        const messageData = {
            ...parsedUserData,
            totalExp: totalExp,
            requiredExp: requiredExp,
            updateTime: new Date().getTime()
        };

        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                type: 'meInfo',
                data: messageData,
            })
        );
    } catch (error) {
        console.error('Failed to send WebView meInfo message:', error);
    }
};

